import createDataContext from './createDataContext';
import * as checklistTemplateActions from './actions/checklistTemplateActions';
import { checklistTemplateReducer, initialState } from './reducers/checklistTemplateReducer';

export const { Context: ChecklistTemplateContext, Provider } = createDataContext(
  checklistTemplateReducer,
  checklistTemplateActions,
  initialState
);
